export { Item as MenuItem } from 'react-stately';
//# sourceMappingURL=MenuItemStately.js.map